import React, { useEffect, useMemo, useState } from "react";

import "./time-picker.scss";

type TimePickerProps = {
  onChange: (time: string) => void;
  validTime: string;
  compareTime?: string;
  placeholder: string;
  isDisabled: boolean;
};

export const CustomTimePicker: React.FC<TimePickerProps> = ({
  onChange,
  validTime,
  placeholder,
  compareTime,
  isDisabled,
}) => {
  const [minTime, setMinTime] = useState("");

  useEffect(() => {
    const now = new Date();
    const currentHoursMinutes = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
    setMinTime(currentHoursMinutes);

    if (compareTime) {
      setMinTime(compareTime);
    }
  }, [compareTime]);

  return useMemo(() => {
    return (
      <div className="timePicker">
        <input
          type="time"
          placeholder={placeholder}
          style={{
            color: validTime.length === 0 ? "transparent" : undefined,
            paddingTop: isDisabled ? "15px" : undefined,
            display: isDisabled ? "inline-flex" : undefined,
            alignItems: isDisabled ? "center" : undefined,
          }}
          onChange={(e) => onChange(e.target.value)}
          value={validTime}
          min={minTime}
          disabled={isDisabled}
          required={true}
        />
      </div>
    );
  }, [onChange, validTime, placeholder, minTime, isDisabled]);
};
